module.exports = __webpack_public_path__ + "static/media/homepage_grid_3.bb38a940.jpg";